import { render, staticRenderFns } from "./CardsGroup.vue?vue&type=template&id=e90d85a2"
import script from "./CardsGroup.vue?vue&type=script&lang=js"
export * from "./CardsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports